import { ChangeDetectionStrategy, Component } from '@angular/core'
import { DialogService } from '@app/core/_services/dialog.service'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons'
import { MessageModule } from 'primeng/message'

@Component({
    selector: 'fm-time-sync-banner',
    imports: [FontAwesomeModule, MessageModule],
    templateUrl: './time-sync-banner.component.html',
    styleUrl: './time-sync-banner.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeSyncBannerComponent {
    public faCircleInfo = faCircleInfo
    constructor(private dialogService: DialogService) {}

    ngOnInit(): void {
        // NOTE: View Banner sent from server time service
    }

    timeSyncInfo() {
        this.dialogService.openTimeSyncInfoDialog()
    }
}
